var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAnc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1422",
    "data-name": "Grupo 1422",
    transform: "translate(-779 -2654)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_112",
    "data-name": "Elipse 112",
    cx: 44.5,
    cy: 44,
    rx: 44.5,
    ry: 44,
    transform: "translate(779 2654)",
    fill: "rgba(0,170,255,0.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(787 2661)",
    fill: "#1de9b6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_942",
    "data-name": "Grupo 942",
    transform: "translate(799.1 2689.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_662",
    "data-name": "Trazado 662",
    d: "M190.927,151.522h-6.5l-1.24,3.065h-3.32l6.24-14.3h3.2l6.26,14.3h-3.4Zm-1.02-2.513-2.22-5.474-2.22,5.474Z",
    transform: "translate(-179.867 -140.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_663",
    "data-name": "Trazado 663",
    d: "M212.932,140.287v14.3h-2.66l-6.98-8.682v8.682h-3.2v-14.3h2.68l6.96,8.682v-8.682Z",
    transform: "translate(-182.932 -140.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_664",
    "data-name": "Trazado 664",
    d: "M218.1,147.393A7.264,7.264,0,0,1,225.7,140a7.162,7.162,0,0,1,5.76,2.533l-2.08,1.961a4.466,4.466,0,0,0-3.52-1.675,4.577,4.577,0,0,0,0,9.151,4.425,4.425,0,0,0,3.52-1.7l2.08,1.961a7.129,7.129,0,0,1-5.78,2.554,7.259,7.259,0,0,1-7.58-7.4",
    transform: "translate(-185.662 -139.998)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnc);
export default __webpack_public_path__ + "static/media/ic_anc.d000a3b3a7ffa634aeaa4908f6facb8f.svg";
export { ForwardRef as ReactComponent };